export default "__VITE_ASSET__b252135c__"